import React from 'react'
import { graphql } from 'gatsby'
import { MDXRenderer } from 'gatsby-plugin-mdx'
import Layout from '../components/Layout'
import Hero from '../components/Hero'

/**
 * Create Page Template Component
 */
const PageTemplate = (props) => {
  return (
    <Layout
      className={`is-page-${props.pageIdentifier || 'unlabelled'} ${props.pageClass || ''}`}
      title={props.title}
      seoTitle={props.seoTitle}
      seoDescription={props.seoDescription}
      heroImage={props.image}
      showContactForm={props.showContactForm}
    >
      <Hero
        // aboveTitle={props.aboveTitle}
        // afterCta={props.afterCta}
        title={props.title}
        subtitle={props.subtitle}
        image={props.image}
        showCta={props.showCta}
        imageAlt={props.imageAlt || props.title}
        ctaUrl={props.ctaUrl}
        ctaText={props.ctaText}
      />
      
      <div className={`container content ${(props.notNarrow === true || props.notNarrow === 'true') ? '' : 'is-narrow'}`}>
        {/* Markdown fallback for CMS Previews */}

        {(() => {
          // If the element is used as <PageTemplate>...</PageTemplate> instead of <PageTemplate />, show children
          if (props.children) {
            return props.children
          }
          // If disableMdx is set, return normal body (for CMS Previews)
          else if (props.disableMdx === true || props.disableMdx === 'true') {
            return props.body
          }
          // Otherwise return the MDX Rendered body
          else if (props.body && props.body.length) {
            return <MDXRenderer>{props.body}</MDXRenderer>
          } else {
            return false
          }
        })()}
      </div>
    </Layout>
  )
}

export { PageTemplate }

/**
 * Fill Page Component with GraphQL Data
 */
const Page = ({ data }) => {
  return (
    <PageTemplate
      // aboveTitle={data.mdx.frontmatter.aboveTitle}
      // afterCta={data.mdx.frontmatter.afterCta}
      title={data.mdx.frontmatter.title}
      pageIdentifier={data.mdx.fields.pageIdentifier}
      seoTitle={data.mdx.frontmatter.seoTitle || ''}
      seoDescription={data.mdx.frontmatter.seoDescription | ''}
      pageClass={data.mdx.frontmatter.pageClass}
      subtitle={data.mdx.frontmatter.subtitle}
      image={data.mdx.fields.image}
      imageAlt={data.mdx.frontmatter.imageAlt}
      showCta={data.mdx.frontmatter.showCta}
      showContactForm={data.mdx.frontmatter.showContactForm}
      body={data.mdx.body}
      ctaUrl={data.mdx.frontmatter.ctaUrl}
      ctaText={data.mdx.frontmatter.ctaText}
      notNarrow={data.mdx.frontmatter.notNarrow}
    />
  )
}

export default Page

export const post = graphql`
  query($id: String!) {
    mdx(id: { eq: $id }) {
      id
      body
      frontmatter {
        title
        pageClass
        templateKey
        showCta
        showContactForm
        subtitle
        seoTitle
        seoDescription
        imageAlt
        ctaUrl
        ctaText
        notNarrow
      }
      fields {
        pageIdentifier
        image {
          childImageSharp {
            fluid(maxWidth: 1920) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`
